import { EventEmitter, Injectable } from "@angular/core";
import { ChassiViewModel } from "src/domain/client";

@Injectable({
  providedIn: "root",
})
export class RedirectBrandService {
  openRedirectBrand$ = new EventEmitter<ChassiViewModel>();

  constructor() {}

  openRedirectBrandComponent(selectedCar: ChassiViewModel): void {
    this.openRedirectBrand$.emit(selectedCar);
  }
}
